import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import authService from "../services/authService";
import { useToast } from "../context/ToastContext";
import { Eye, EyeOff } from "lucide-react";
import "./SignUp.css";

function Signup() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const { addToast } = useToast();

    const handleRegister = async (e) => {
        e.preventDefault();
        try {
            await authService.register(name, email, password);
            addToast("Account created successfully!", "success");
            navigate("/");
        } catch (err) {
            const msg = err.response?.data?.message || "Registration failed";
            setError(msg);
            addToast(msg, "error");
        }
    };

    return (
        <div className="signup-container">
            <h1>ERP System</h1>
            <p>Business Management & Invoice System</p>
            <h2>Create Account</h2>
            {error && <p style={{ color: "red" }}>{error}</p>}
            <form onSubmit={handleRegister}>
                <label>Full Name</label>
                <br />
                <input
                    type="text"
                    placeholder="Your Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                />
                <br />
                <label>Email</label>
                <br />
                <input
                    type="email"
                    placeholder="admin@company.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <br />
                 <label>Password</label>
                <br />
                <div style={{ position: 'relative' }}>
                    <input
                        type={showPassword ? "text" : "password"}
                        placeholder="enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        minLength={6}
                        style={{ paddingRight: '40px', width: '100%' }}
                    />
                    <span 
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ 
                            position: 'absolute', 
                            right: '12px', 
                            top: '50%', 
                            transform: 'translateY(-50%)', 
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        {showPassword ? <EyeOff size={18} color="#EF4444" /> : <Eye size={18} color="#3B82F6" />}
                    </span>
                </div>
                <br />
                <br />
                <button type="submit">Sign Up</button>
            </form>
            <p style={{ marginTop: "20px" }}>
                Already have an account? <Link to="/login">Login here</Link>
            </p>
        </div>
    );
}

export default Signup;